<template>
  <div id="app">
    <app-header v-if="$route.name != 'invitacion-webinar'"></app-header>
    <router-view/>
    <app-footer v-if="$route.name != 'invitacion-webinar'"></app-footer>

    
  </div>
</template>

<script>

  require('waypoints/lib/noframework.waypoints.js')

  import header from '@/components/parts/header'
  import footer from '@/components/parts/footer'


  export default {
    name: 'App',
    components : {
      'app-header' : header,
      'app-footer' : footer,
    },
    mounted (){
      this.waypoints();
    },
    watch : {
      '$route' : function(){
        let that = this;
        setTimeout(function(){
          that.waypoints();
        },100);
      }
    },
    methods : {
      waypoints : function() {

        $(".waypoints-instant").addClass('animated fadeInUp');

        var waypoints = document.getElementsByClassName('waypoints');

        for (var i = 0; i < waypoints.length; i++) {

          new Waypoint({
            element: waypoints[i],
            offset : '100%',
            handler: function() {
              var element = this.key.split('-')[1];
              var effect = this.element.attributes.getNamedItem('data');
              (effect != undefined) ? effect = effect.value : effect = "fadeIn";
              this.element.classList.add("animated", effect)  
            }
          });

        }

        var waypoints = document.getElementsByClassName('contenedor-imagen');

        for (var i = 0; i < waypoints.length; i++) {

          new Waypoint({
            element: waypoints[i],
            offset : '100%',
            handler: function() {
              this.element.classList.add("active");  
            }
          });

        }

      }
    }
  }
</script>

<style>
@import './assets/css/style.css';
@import './assets/css/slick.css';
@import url('https://fonts.googleapis.com/css?family=Ubuntu+Mono|Roboto:300,400,600,700,800');
@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css);
@import url(https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css);
</style>



// WEBPACK FOOTER //
// src/App.vue